// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"7":"3dcd80f7","364":"94cf1415","450":"a8294982","702":"94254da4","786":"ed0ef39f","899":"8388dd56"}[chunkId] + ".css";
};